$('#currency_switcher_form select').on('change', function () {
  $('#currency_switcher_form input[name=return_to]').val(
    window.location.pathname
  );
  $('#currency_switcher_form').addClass('currency_switcher_form');
  $('.currency_switcher_form').trigger('submit');
});
